import React, { useState } from 'react';
import { useController } from './controller';
import { useParticles } from './particles';
import * as S from './styles';
import DefaultLoading from '../../components/DefaultLoading';
import { translations, LanguageKeys } from './translation';
import { Helmet } from "react-helmet"

const LandingPage = (props: any) => {
    const controller = useController();

    return (
        <S.mainContainer>
            <S.loginHeader>
                <S.headerButtonsWrapper>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/login')}>
                        {translations['EN'].ctaButtonLogin}
                    </S.headerButton>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/register')}>
                        {translations['EN'].ctaButtonRegister}
                    </S.headerButton>
                </S.headerButtonsWrapper>
            </S.loginHeader>
            <S.mainInfo>
                <S.ctaArea>
                    <S.mainTitle>
                        {translations['EN'].mainTitle}
                    </S.mainTitle>
                    <S.subTitle>
                        {translations['EN'].subTitle}
                    </S.subTitle>
                    <S.startCta onClick={() => controller.general.GoToRoute('/register')}>
                        {translations['EN'].ctaButton}
                    </S.startCta>
                </S.ctaArea>
                <S.advantagesArea>
                    {translations['EN'].advantages.map((advantage, index) => (
                        <S.advantage>
                            <S.advantageTitle>
                                {advantage.title}
                            </S.advantageTitle>
                            <S.advantageSubtitle>
                                {advantage.description}
                            </S.advantageSubtitle>
                        </S.advantage>
                    ))}
                </S.advantagesArea>
            </S.mainInfo>
        </S.mainContainer>
    )
}

const MountedComponent = (props: any) => {
    const particles = useParticles();

    return (
        <>
            <LandingPage />
            <S.particles
                id="tsparticles"
                particlesLoaded={particles.particlesLoaded as any}
                options={particles.options}
            />
        </>
    )
}

export default MountedComponent;